export default "__VITE_ASSET__Duh1oYsa__"